// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    IOrderCost,
}                               from '../interfaces';

const stripeGetTaxCalculationOrderCost = async ({
    test,
    taxCalculationId,
}: {
    test: boolean,
    taxCalculationId: string,
}): Promise<IOrderCost | null> => {
    const functions = getFunctions();
    const getTaxCalculationOrderCost = httpsCallable<
        {
            test: boolean,
            taxCalculationId: string,
        },
        IOrderCost | null
    >(
        functions,
        'stripeGetTaxCalculationOrderCost',
    );

    return getTaxCalculationOrderCost({
        test,
        taxCalculationId,
    }).then((result) => {
        const orderCost = result.data as IOrderCost | null;
        return orderCost;
    }).catch((err) => {
        throw err;
    });
};

export default stripeGetTaxCalculationOrderCost;
